<template>
    <v-card outlined>
        <v-data-table
            :headers="headers"
            :items="list"
            :items-per-page="-1"
            hide-default-footer
            disable-pagination
            disable-sort
            disable-filtering
            :loading="fetching"
            item-key="numero"
            dense
            >
            <template v-slot:[`item.identifier`]="slotProps">
                    <slot v-bind="slotProps" />
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.tickets="{ item }">
                <v-btn small class="mr-2" text>
                    <v-icon class="mr-2" small>mdi mdi-receipt-text</v-icon>
                    {{ item.count }}
                </v-btn>
            </template>

            <!-- eslint-disable-next-line -->
            <template v-slot:item.venta="{ item }">
                {{ item.venta | currency(item.divisa_code) }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.comision="{ item }">
                {{ item.comision | currency(item.divisa_code) }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.projected="{ item }">
                <v-chip small label :color="item.premioColor" class="font-weight-bold mr-2">
                    {{ item.projected | currency(item.divisa_code) }} {{' / '}} {{ item.percent_premio | percent }}
                </v-chip>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.total_projected="{ item }">
                <v-chip small label :color="item.sorteoColor" class="font-weight-bold mr-2">
                    Sorteo <v-divider vertical class="mx-3"/> {{ item.related.sorteo.total | currency(item.divisa_code) }}
                </v-chip>
                <v-chip small label :color="item.dayColor" class="font-weight-bold mr-2">
                    Día <v-divider vertical class="mx-3"/> {{ item.related.day.total | currency(item.divisa_code) }}
                </v-chip>
                <v-chip small label :color="item.weekColor" class="font-weight-bold">
                    Semana <v-divider vertical class="mx-3"/> {{ item.related.week.total | currency(item.divisa_code) }}
                </v-chip>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import ReportePorFiguraService from '@/services/reporte/ventas/ReportePorFiguraService';

const reportDefault = {
    summary: {},
    detail: [],
};

export default {
    components: {
    },
    props: {
        params: {
            defaults: function() {
                return {

                };
            },
        },
        context: {
            default: 'comercio',
        },
        loading: {
            type: Boolean,
            default: true,
        },
        limited: {
            type: Boolean,
            default: false,
        }
    },
    data: function() { 
        return {
            report:  { ... reportDefault },
            fetching: true,
            expanded: [],
        }
    },
    computed: {
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        },
        reportComputed: function () {
            return this.report;
        },
        list: function () {
            return this.report.detail.map(report => {
                return {
                    ...report,
                    premioColor: report.percent_premio <= 1 ? 'primary': 'error',
                    sorteoColor: report.related.sorteo.total == 0 
                                    ? 'secondary' 
                                    : report.related.sorteo.total > 0 
                                        ? 'primary'
                                        : 'error',
                    dayColor: report.related.day.total == 0 
                                    ? 'secondary' 
                                    : report.related.day.total > 0 
                                        ? 'primary'
                                        : 'error',
                    weekColor: report.related.week.total == 0 
                                    ? 'secondary' 
                                    : report.related.week.total > 0 
                                        ? 'primary'
                                        : 'error',
                }
            })
        },
        summary: function () {
            return this.report.summary;
        },
        headers: function () {
            return [
                { text: '', value: 'identifier' },
                { 
                    text: 'Tickets',
                    align: 'start',
                    value: 'tickets' 
                },
                { 
                    text: 'Ventas',
                    align: 'center',
                    value: 'venta' 
                },
                { 
                    text: 'Comisión',
                    align: 'center',
                    value: 'comision' 
                },
                { 
                    text: 'Premio',
                    align: 'center',
                    value: 'projected' 
                },
                { 
                    text: 'Total',
                    align: 'start',
                    value: 'total_projected' 
                },
            ];
        },
    },
    methods: {
        getLegibleDistanciaFecha: function (date) {
            if (!date) return 0;

            const start = this.$luxon.fromSQL(date);
            const end = this.$luxon.now();

            const days = Math.floor(end.diff(start, 'days').toObject().days);

            return days;
        },
        fetchReport: function (params = {}) {
            this.report = { ... reportDefault };
            this.fetching = true;

            const parameters = {...this.params, ...params, divisa_id: this.divisa.id};

            if (this.context == 'sistema') {
                parameters['group_by'] = 'sistema';
                parameters['comercio_type'] = 'sistema';
            }

            ReportePorFiguraService.getConsolidado(parameters)
                .then(({ report }) => {
                    this.report = report;
                }).finally(() => {
                    this.fetching = false;
                });
        },
    },
    watch: { 
        'params': function () {
            this.fetchReport();
        },
        'divisa': function () {
            this.fetchReport();
        },
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    },
    mounted: function () {
        this.$emit('update:loading', this.fetching);
        this.fetchReport();
    }
}
</script>
<style>

</style>